import React from "react";
import { Chip } from "@mui/material";

export type StatusTone = "default" | "success" | "warning" | "danger" | "info";

export interface StatusBadgeProps {
  label: string;
  tone?: StatusTone;
}

const styles: Record<StatusTone, { bg: string; color: string }> = {
  default: { bg: "#EEF2F4", color: "#33495C" },
  success: { bg: "#DFF4E7", color: "#1E8449" },
  warning: { bg: "#FBE7BE", color: "#9A6708" },
  danger: { bg: "#F5D0CC", color: "#A93226" },
  info: { bg: "#D7EBF8", color: "#2471A3" },
};

export default function StatusBadge({ label, tone = "default" }: StatusBadgeProps) {
  const s = styles[tone];

  return (
    <Chip
      size="small"
      label={label}
      sx={{
        borderRadius: "8px",
        fontWeight: 700,
        bgcolor: s.bg,
        color: s.color,
      }}
    />
  );
}
